import { useState, useEffect } from 'react';

export function ConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('analytics_consent');
    // Only show if user hasn't made a choice yet
    if (consent === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('analytics_consent', 'accepted');
    setShowBanner(false);
    // Initialize analytics if gtag is available
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted'
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('analytics_consent', 'declined');
    setShowBanner(false);
    // No reload needed - just hide banner
  };

  // Don't render if user already made a choice
  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-[#0E0D0C]/95 backdrop-blur-lg border-t border-[#0CB4E4]/20 py-3 px-3 sm:px-6 sm:py-4 z-50"
      style={{
        animation: 'slideUp 0.3s ease-out'
      }}
      role="dialog"
      aria-label="Cookie consent"
      aria-live="polite"
    >
      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
      
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
        <div className="flex-1 text-center sm:text-left">
          <p className="text-xs sm:text-sm text-gray-300">
            We use cookies to analyse site usage and to improve our services. No personal data is collected or sold.{' '}
            <a 
              href="/privacy" 
              className="text-[#0CB4E4] hover:text-[#0CB4E4]/80 underline transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read our cookie policy here
            </a>
          </p>
        </div>
        
        <div className="flex items-center gap-3 sm:gap-4">
          <button
            onClick={handleDecline}
            className="py-2 px-4 sm:px-5 text-xs sm:text-sm text-gray-300 hover:text-white transition-colors font-medium"
            aria-label="Decline analytics"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 sm:px-5 py-2 sm:py-2.5 text-xs sm:text-sm bg-gradient-to-r from-[#0CB4E4] to-[#0CB4E4]/80 text-[#161513] rounded-lg sm:rounded-xl hover:shadow-lg transition-all font-medium"
            aria-label="Accept analytics"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}